import { Fragment } from 'react';

import type { SlaHeatmapVM } from '../../view-models';
import type React from 'react';

export function SlaHeatmapChart({ heatmap }: { heatmap: SlaHeatmapVM }): React.JSX.Element {
  return (
    <div className="sla-heatmap">
      <div
        className="sla-heatmap__grid"
        style={{ gridTemplateColumns: `60px repeat(${heatmap.buckets.length}, 1fr)` }}
      >
        <div className="ti-heatmap__corner" />
        {heatmap.buckets.map((b) => (
          <div key={b} className="ti-heatmap__head">
            {b}
          </div>
        ))}
        {heatmap.rows.map((row) => (
          <Fragment key={row.day}>
            <div className="ti-heatmap__row-label">{row.day}</div>
            {row.cells.map((c, i) => (
              <div
                key={i}
                className={
                  c === null ? 'sla-heatmap__cell' : 'sla-heatmap__cell sla-heatmap__cell--' + c
                }
              >
                {c === 'ok' ? '✓' : c === 'warn' ? '⚠' : c === 'crit' ? '🔴' : '–'}
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
